import {
  TEMPLATE_LOAD_COLLECTIONS_BEGIN,
  TEMPLATE_LOAD_COLLECTIONS_SUCCESS,
  TEMPLATE_LOAD_COLLECTIONS_FAILURE,
  TEMPLATE_LOAD_COLLECTIONS_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadCollections(args = {}) {
  return (dispatch) => {
    dispatch({
      type: TEMPLATE_LOAD_COLLECTIONS_BEGIN,
    });
    const { version, projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${projectId}/project`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: TEMPLATE_LOAD_COLLECTIONS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: TEMPLATE_LOAD_COLLECTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCollectionsError() {
  return {
    type: TEMPLATE_LOAD_COLLECTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_LOAD_COLLECTIONS_BEGIN:
      return {
        ...state,
        loadCollectionsPending: true,
        loadCollectionsError: null,
      };

    case TEMPLATE_LOAD_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loadCollectionsPending: false,
        loadCollectionsError: null,
        collections: action.data,
      };

    case TEMPLATE_LOAD_COLLECTIONS_FAILURE:
      return {
        ...state,
        loadCollectionsPending: false,
        loadCollectionsError: action.data.error,
      };

    case TEMPLATE_LOAD_COLLECTIONS_DISMISS_ERROR:
      return {
        ...state,
        loadCollectionsError: null,
      };

    default:
      return state;
  }
}
